import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export const store = new Vuex.Store({
    state: {
        listState: 'LIST',
        configLoaded: false,
        config: {},
        errors: [],
        sendData: {},
        savedMap: null,
        savedView: null,
        encodedData: null,
        items: [],
        locationsById: {},
        textFilter: "",
        spatialFilter: false,
        filteredLocationIds: [],
        currLocationType: 'NONE',
        nearbyLocations: [],
        currItem: {},
        hoverId: 0,
        captcha: {
            handlerUrl: "https://gisapp.brandon.ca/webservices/EnquiryFormBackend/recaptcha_handler.aspx",
            publicKey: "6LdE1XYUAAAAAKJgbLE0sQMG_h-jN5ijBbhaB_da",
            token: null
        },
        emptyLocation: function () {
            return {
                address: '',
                email: '',
                days: "Both",
                // phone: '',
                // name: '',
                // notes: '',
                comments: '',
                latitude: 0,
                longitude: 0
            }
        }
    },
    mutations: {
        setListState(state) {
            state.listState = "LIST"
        },
        setEditState(state) {
            state.listState = "EDIT"
        },
        setDeleteState(state) {
            state.listState = "DELETE"
        },
        setSelectState(state) {
            state.listState = "SELECT"
        },
        setHoverId(state, id) {
            if (id !== null && id !== undefined && state.hoverId !== id)
                state.hoverId = id;
        },
        setEncodedData(state, data) {
            state.encodedData = data;
        },
        resetHoverId(state) {
            state.hoverId = 0;
        },
        setTextFilter(state, text) {
            state.textFilter = text;
        },
        clearTextFilter(state) {
            state.stateTextFilter = ""
        },
        setSpatialFilterTrue(state) {
            state.spatialFilter = true;
        },
        setSpatialFilterFalse(state) {
            state.spatialFilter = false;
        },
        setFilteredLocationIds(state, ids) {
            state.filteredLocationIds = ids;
        },
        currLocationTypeNone(state) {
            state.currLocationType = 'NONE'
        },
        currLocationTypeNew(state) {
            state.currLocationType = 'NEW'
        },
        currLocationTypeExisting(state) {
            state.currLocationType = 'EXISTING'
        },
        configLoaded(state) {
            state.configLoaded = true;
        },
        setConfig(state, config) {
            state.config = config
        },
        setCaptchaToken(state, token) {
            state.captcha.token = token;
        },
        setMap(state, map) {
            state.savedMap = map;
        },
        setView(state, view) {
            state.savedView = view;
        },
        setData(state, { key, value }) {
            Vue.set(state.sendData, key, value); // Use Vue.set for reactivity
        },
        setItems(state, items) {
            state.items = items;
            state.locations = {};
            items.forEach((item) => {
                state.locationsById[item.id] = item;
            });
        },
        clearCurrItem(state) {
            state.currItem = state.emptyLocation();
        },
        setCurrItem(state, item) {
           state.currItem = item;
        },
        setNearbyLocations(state, locations) {
            state.nearbyLocations = locations;
        },
        clearNearbyLocations(state) {
            state.nearbyLocations = [];
        },
        addItem(state, item) {
            state.items.push(item);
            state.locationsById[item.id] = item;
        },
        clearItems(state) {
            state.items = [];
        },
        addError(state, error) {
            state.errors.push(error);
        },
        clearErrors(state) {
            state.errors = [];
        }
    }
})